import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import {PerformanceReviewReviewerViewModel} from 'main/stores/performance_reviews';

class TextFieldResultState {
  store = new DomainStore();

  question;
  reviews;
  viewReviews;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({question, uiState}) {
    this.question = question;
    this.reviews = uiState.currentReviews;
  }

  get reviewerGroupedReviews() {
    return _.groupBy(this.reviews, 'reviewer.id');
  }

  get reviewerViewModels() {
    return Object.values(this.reviewerGroupedReviews)
      .map(r => new PerformanceReviewReviewerViewModel(r, this));
  }

  reviewsForReviewer(reviewerId) {
    return _.filter(this.reviews, { reviewer: { id: reviewerId }});
  }
}

export default TextFieldResultState;
